import axios from 'axios';
import { LOGOUT_ENDPOINT } from '../constants/endpoint';

export default async () => {
  const response = await axios.post(LOGOUT_ENDPOINT);
  return response;
};
